import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_BALANCE_HISTORIES_BY_USER_API_ID =
  'FETCH_STOCK_BALANCE_HISTORIES_BY_USER_API_ID';

const apiCall = createApiCall(
  FETCH_STOCK_BALANCE_HISTORIES_BY_USER_API_ID,
  ({ user_id, ...params }: { user_id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/users/${user_id}/stock-balance-histories`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
